export class OfertaProduto {
    idofertaproduto: number;
    idoferta: number;
    idproduto: number;
    dtcriacao: Date;
    dtalteracao: Date;
}
